import React from "react";
import { motion } from "framer-motion";

interface ImageProps {
  src: string; // Source of the image
  className?: string; // Tailwind CSS classes for styling
  loading?: "lazy" | "eager"; // Loading behavior
  onClick?: () => void; // Optional click handler
  testId?: string;
  objectFit?: string;
  disabled?: boolean;
  tableActions?: boolean;
}

const Image: React.FC<ImageProps> = ({
  src,
  className = "",
  loading = "lazy",
  onClick,
  testId,
  objectFit,
  tableActions

}) => {
  // Framer Motion animation variants
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.5 }, // Initially invisible and slightly scaled down
    visible: { opacity: 1, scale: 1 }, // Fully visible and normal scale
  };

  return (
    <motion.img
      src={`/images/${src}.svg`}
      alt={src}
      className={`${objectFit ? objectFit : 'object-cover'}  ${className}`}
      loading={loading}
      onClick={onClick}
      variants={tableActions ? {} : imageVariants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.6, ease: "easeOut" }} // Smooth animation
      data-testid={testId}
    />
  );
};

export default Image;
